import { lazyLoad } from 'utils/loadable';

export const SearchResultsWrapperLoadable = lazyLoad(
  () => import('./SearchResultsWrapper'),
  module => module.SearchResultsWrapper,
);
